import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// import 'chart.js';

// import 'bootstrap';
// import 'bootstrap/dist/css/bootstrap.css';

// import * as async from 'async';

// import { Location } from '@angular/common';

// const __stripTrailingSlash = (Location as any).stripTrailingSlash;
// // (Location as any).stripTrailingSlash = function _stripTrailingSlash(url: string): string {
// // 	console.log(url)
// //   const queryString$ = url.match(/([^?]*)?(.*)/);
// //   if (queryString$[2].length > 0) {
// //   	var x = /[^\/]\/$/.test(queryString$[1]) ? queryString$[1] + '.' + queryString$[2] : __stripTrailingSlash(url);
// //   	console.log(x)
// //     return x
// //   }
// //   var y = /[^\/]\/$/.test(url) ? url + '.' : __stripTrailingSlash(url);
// //   return y
// // };

// (Location as any).stripTrailingSlash = function _stripTrailingSlash(url: string): string {
// 	// if (url.endsWith('/')) {
// 	//   //url = url.substring(0, url.length - 1);
// 	// }
// 	console.log(url)
// 	return url;
// };

if (environment.production) {
    enableProdMode();
}
// Upgrade to angular-cli
// console.info('app.environment:', app.environment);
// if (app.environment === 'production') {
//   enableProdMode();
// }

// platformBrowserDynamic().bootstrapModule(AppModule, {providers: [ { provide: BrowserXhr, useExisting: CustomBrowserXhr }]});
platformBrowserDynamic().bootstrapModule(AppModule, {
    // keep zone.js change detection (Angular 21 defaults to zoneless)
    applicationProviders: [provideZoneChangeDetection()],
});
